import { createAction, props } from '@ngrx/store';
import { ApiKeysFilter, ApiKeyTokenSecret, ApiKeyType, OrgTypes } from '@mode/shared/contract-common';
import { ModeForm, PaginationTypes } from '@mode/shared/contract-common';
import { HttpErrorResponse } from '@angular/common/http';

export const loadApiKeys = createAction(
  '[ApiKeys] Load ApiKeys',
  props<{
    username: string;
    page: number;
    query: string;
    filter: ApiKeysFilter | null;
  }>()
);

export const loadApiKeysSuccess = createAction(
  '[ApiKeys] Load ApiKeys Success',
  props<{
    pagination: PaginationTypes.Pagination;
    apiKeys: OrgTypes.ApiKey[];
    apiKeyCreateForm: ModeForm | undefined;
  }>()
);

export const loadApiKeysFailure = createAction('[ApiKeys] Load ApiKeys Failure', props<{ error: Error }>());

export const loadMemberApiKeys = createAction(
  '[ApiKeys] Load Member ApiKeys',
  props<{
    username: string;
    page: number;
    query: string;
    memberUsername: string;
  }>()
);

export const loadMemberApiKeysSuccess = createAction(
  '[ApiKeys] Load Member ApiKeys Success',
  props<{
    pagination: PaginationTypes.Pagination;
    apiKeys: OrgTypes.ApiKey[];
    apiKeyCreateForm: ModeForm | undefined;
  }>()
);

export const loadMemberApiKeysFailure = createAction(
  '[ApiKeys] Load Member ApiKeys Failure',
  props<{ error: Error }>()
);

export const loadMemberApiKeysEnabled = createAction('[ApiKeys] Load Member API Keys Enabled');

export const loadMemberApiKeysEnabledSuccess = createAction(
  '[ApiKeys] Load Member API Keys Enabled Success',
  props<{ enabled: boolean }>()
);

export const revokeApiKey = createAction('[ApiKeys] Revoke ApiKey', props<{ token: string }>());

export const revokeApiKeySuccess = createAction('[ApiKeys] Revoke ApiKey Success', props<{ token: string }>());

export const revokeApiKeyFailure = createAction('[ApiKeys] Revoke ApiKey Failure', props<{ error: Error }>());

export const reloadApiKeys = createAction('[ApiKeys] Reload ApiKeys');

export const createApiKey = createAction(
  '[ApiKeys] Create ApiKey',
  props<{ workspace: string; member?: string; config: OrgTypes.ApiKeyConfig }>()
);

export const createApiKeySuccess = createAction('[ApiKeys] Create ApiKey Success', props<ApiKeyTokenSecret>());

export const createApiKeyFailure = createAction(
  '[ApiKeys] Create ApiKey Failure',
  props<{ error: Error | HttpErrorResponse }>()
);

export const revokeAllApiKeys = createAction('[ApiKeys] Revoke All ApiKeys', props<{ workspaceUsername: string }>());

export const revokeAllApiKeysSuccess = createAction('[ApiKeys] Revoke All ApiKeys Success');

export const revokeAllApiKeysFailure = createAction('[ApiKeys] Revoke All ApiKeys Failure', props<{ error: Error }>());

export const bulkRevokeApiKeys = createAction(
  '[ApiKeys] Bulk Revoke ApiKeys',
  props<{ workspace: string; member?: string; keyType?: ApiKeyType }>()
);

export const bulkRevokeApiKeysSuccess = createAction('[ApiKeys] Bulk Revoke ApiKeys Success');

export const bulkRevokeApiKeysFailure = createAction(
  '[ApiKeys] Bulk Revoke ApiKeys Failure',
  props<{ error: Error }>()
);

export const updateMemberApiKeysEnabled = createAction(
  '[ApiKeys] Update Member API Keys Enabled',
  props<{ workspaceUsername: string; enabled: boolean }>()
);

export const updateMemberApiKeysEnabledSuccess = createAction(
  '[ApiKeys] Update Member API Keys Enabled Success',
  props<{ enabled: boolean | undefined }>()
);

export const updateMemberApiKeysEnabledFailure = createAction(
  '[ApiKeys] Update Member API Keys Enabled Failure',
  props<{ error: Error | HttpErrorResponse }>()
);
